import React from "react";
import Slider from "react-slick";
import { Box } from "@mui/material";

const AutoPhotoSlider = ({ slides }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    lazyLoad: 'ondemand',
  };

  return (
    <Box sx={{
      width: "100%",
      height: "100%",
      overflow: "hidden",
      zIndex: -1,
      // Force all slick internals to fill the height
      '& .slick-slider': { height: '100%' },
      '& .slick-list': { height: '100%' },
      '& .slick-track': { height: '100%' },
      '& .slick-slide': { height: '100%' },
      '& .slick-slide > div': { height: '100%' },
    }}>
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              width: '100%',
              height:'100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={slide.image}
              alt={slide.title}
              sx={{
                width: '100%',
                height: '100%',
                maxHeight: '100vh',
                objectFit: 'cover',
                animation: 'kenBurns 20s infinite alternate ease-in-out',
                '@keyframes kenBurns': {
                  '0%': { transform: 'scale(1)' },
                  '100%': { transform: 'scale(1.15)' }
                },
                '@media (prefers-reduced-motion: reduce)': {
                  animation: 'none',
                }
              }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default AutoPhotoSlider;